import { Serializer } from './Serializer';
import {
  paragraphSerializer,
  textSerializer,
  headingSerializer,
  emphasisSerializer,
  listItemSerializer,
  quoteSerializer,
  imageSerializer,
} from './nodes';
import {
  boldSerializer,
  italicSerializer,
  linkMarkSerializer,
  mentionMarkSerializer,
} from './mark';

const articleSerializer = new Serializer({
  nodeSerializers: [
    textSerializer,
    headingSerializer,
    paragraphSerializer,
    emphasisSerializer,
    listItemSerializer,
    quoteSerializer,
    imageSerializer,
  ],
  markSerializers: [
    boldSerializer,
    italicSerializer,
    linkMarkSerializer,
    mentionMarkSerializer,
  ],
});

export { articleSerializer };
